import { ConfigStore } from "fs-pb-vue2/store/modules/config";
import { Prop, Ref } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "fs-pb-vue2/vueModels/operations/OperationVue";
import { CardModel } from "fs-pb-vue2/models/contracts/cardModel";
import { ContractsStore } from "fs-pb-vue2/store/modules/contracts";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import IOperationService from "fs-pb-vue2/services/operations/IOperationService";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { CashBackCategoryModel } from "../../models/cardOperations/CashBackCategoryModel";

 export class CashBackModalVue extends OperationVue {

  /** Входные параметры */
  @Prop() data!: CardModel;

  /** Входные параметры */
  @Prop() params!: any;

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
    get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
   * Сервис проведения операций каталога
   * @returns {IOperationService}
   */
  get operationService(): IOperationService {
    return container.get<IOperationService>(DiTokens.CashBackSelectService);
  }
  
  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */  
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
   * Код операции
   * @returns {string} - код для отправки апи.
   */
   get respondentCode(): string {
    return this.configStore.apiData.OperationSelectCategoryCashBack;
  }

  /** Инициализация формы */
  async init(): Promise<void> {
    await this.initOperation();
  }

  /**Следующий шаг операции */
  async next(): Promise<void> {
    try {
      this.execLoading = true;
      this.OperationModel = await this.service.nextStep(this.OperationModel);

      if (this.OperationModel.IsSuccess || this.OperationModel.IsExecuting || this.OperationModel.IsError) {
        await this.service.afterExecute(this.OperationModel);
        await this.afterExecute();
      }
      this.execLoading = false;
    }
    catch (e) {
      this.execLoading = false;
      throw e;
    }
  }

  async onCategoryClick(category: any): Promise<void> {
    try {
      this.loading = true;
      this.OperationModel.selectedCategory = category.caption; 
      await this.next()
    } catch (error) {
      this.loading = false;
      throw error;
    } finally {
      this.loading = false;
    }
  }

  /** Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.CashBackSelectService);
    this.OperationModel = (await this.operationService.init({
      code: this.respondentCode,
      card: this.params.card,
      contract: this.params.contract,
      categoryCaption: this.params.categoryCaption
    })) as CashBackCategoryModel;
    this.loading = false;
  }
}